import { useState } from "react";
import validator from "validator";
import LogoComponent from "../../components/Logos/LogoComponent";
import BackButton from "../../components/buttons/BackButton";
import { useRateLimiter } from "hooks/useRateLimiter";
const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3080";

export let forgotPasswordController;

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");

  // define event to listen for in rate limiter
  const checkLimitEvent = new Event("checkLimit");
  // limit 3 requests per minute from this page
  useRateLimiter();

  const handleFormSubmit = (e) => {
    e.preventDefault();
    setEmailError("");

    if (!validator.isEmail(email)) {
      return setEmailError("Please enter a valid email");
    } else {
      // reset controller and dispatch event listened for in useRateLimiter()
      forgotPasswordController = new AbortController();
      window.dispatchEvent(checkLimitEvent);
      // this fetch listens for the signal send from useRateLimiter()
      fetch(`${API_URL}/sendPasswordReset`, {
        signal: forgotPasswordController.signal,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email: email }),
      })
        .then((r) => r.json())
        .then((r) => {
          if ("success" === r.message) {
            alert("Please check your email for the password reset link.");
          } else {
            alert(r.message);
          }
        })
        .catch((err) => {
          alert("Too many requests. Please try again later.");
        });
    }
  };

  return (
    <div className="d-flex flex-column min-vh-100 justify-content-center align-items-center">
      <div style={{ maxWidth: "30rem" }}>
        <div className="mb-4">
          <LogoComponent />
        </div>

        {/* CONTAINER */}
        <div className="d-flex flex-column justify-content-center align-items-start gap-4">
          {/* BACK BUTTON */}
          <div className="me-auto">
            <BackButton />
          </div>
          <div className="mb-2">
            <h3 className="heading-secondary mb-3">Forgot Password?</h3>
            <p style={{ fontSize: "1.2rem" }}>
              Fear not. We'll email you instructions to reset your password.
            </p>
          </div>

          {/* FORM */}
          <form onSubmit={handleFormSubmit} noValidate className="w-100 gap-4">
            <div className="mb-5">
              <input
                className="form-control"
                type="email"
                name="email"
                placeholder="Email"
                value={email}
                aria-describedby="emailHelp"
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <label className="errorLabel">{emailError}</label>
            </div>
            <button type="submit" className="btn  fw-bold bg-main-purple w-100">
              Reset Password
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
